webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/* exports provided: API_URL, HEARTBEAT_ATTEMPT_INTERVAL */
/* exports used: API_URL, HEARTBEAT_ATTEMPT_INTERVAL */
/*!**************************!*\
  !*** ./src/constants.js ***!
  \**************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HEARTBEAT_ATTEMPT_INTERVAL; });
var API_URL = 'http://192.168.123.1';
var HEARTBEAT_ATTEMPT_INTERVAL = 3 * 1000;

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/* exports provided: vue */
/* all exports used */
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "vue", function() { return vue; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_App_vue__ = __webpack_require__(/*! ./components/App.vue */ 46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_App_vue__);



var vue = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__components_App_vue___default.a);
  }
});

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/* exports provided: default */
/* all exports used */
/*!**************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/pipeline/source/~/babel-preset-vue-app/dist/index.common.js",{"useBuiltIns":true}]]}!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/App.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProgressBar_vue__ = __webpack_require__(/*! ./ProgressBar.vue */ 47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProgressBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ProgressBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__steps_Connection_vue__ = __webpack_require__(/*! ./steps/Connection.vue */ 48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__steps_Connection_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__steps_Connection_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__steps_Info_vue__ = __webpack_require__(/*! ./steps/Info.vue */ 49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__steps_Info_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__steps_Info_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__steps_Wifi_vue__ = __webpack_require__(/*! ./steps/Wifi.vue */ 53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__steps_Wifi_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__steps_Wifi_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__steps_Mqtt_vue__ = __webpack_require__(/*! ./steps/Mqtt.vue */ 50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__steps_Mqtt_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__steps_Mqtt_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__steps_Settings_vue__ = __webpack_require__(/*! ./steps/Settings.vue */ 52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__steps_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__steps_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__steps_Sending_vue__ = __webpack_require__(/*! ./steps/Sending.vue */ 51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__steps_Sending_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__steps_Sending_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: false,
      loadingText: '',
      currentStep: 1,
      deviceInformation: {},
      config: {}
    };
  },

  methods: {
    goToNextStep: function goToNextStep() {
      this.currentStep++;
    },
    setLoading: function setLoading(text) {
      this.loadingText = text;
      this.loading = true;
    },
    stopLoading: function stopLoading() {
      this.loading = false;
    },
    receiveDeviceInformation: function receiveDeviceInformation(deviceInformation) {
      this.deviceInformation = deviceInformation;
    },
    receiveWifiConfig: function receiveWifiConfig(config) {
      this.config.wifi = config;
    },
    receiveMqttConfig: function receiveMqttConfig(config) {
      this.config.mqtt = config;
    },
    receiveSettingsConfig: function receiveSettingsConfig(config) {
      this.config.name = config.name;
      this.config.ota = { enabled: config.ota };
      if (config['device_id']) this.config['device_id'] = config['device_id'];
      if (Object.keys(config.settings).length !== 0) this.config.settings = config.settings;
    }
  },
  components: {
    ProgressBar: __WEBPACK_IMPORTED_MODULE_0__ProgressBar_vue___default.a,
    ConnectionStep: __WEBPACK_IMPORTED_MODULE_1__steps_Connection_vue___default.a,
    InfoStep: __WEBPACK_IMPORTED_MODULE_2__steps_Info_vue___default.a,
    WifiStep: __WEBPACK_IMPORTED_MODULE_3__steps_Wifi_vue___default.a,
    MqttStep: __WEBPACK_IMPORTED_MODULE_4__steps_Mqtt_vue___default.a,
    SettingsStep: __WEBPACK_IMPORTED_MODULE_5__steps_Settings_vue___default.a,
    SendingStep: __WEBPACK_IMPORTED_MODULE_6__steps_Sending_vue___default.a
  }
});

/***/ }),
/* 30 */
/* exports provided: default */
/* all exports used */
/*!**********************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/pipeline/source/~/babel-preset-vue-app/dist/index.common.js",{"useBuiltIns":true}]]}!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/ProgressBar.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  props: ['currentStep']
});

/***/ }),
/* 31 */
/* exports provided: default */
/* all exports used */
/*!***************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/pipeline/source/~/babel-preset-vue-app/dist/index.common.js",{"useBuiltIns":true}]]}!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/steps/Connection.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(/*! axios */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(/*! ../../constants */ 3);
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      requestOnGoing: false,
      interval: null
    };
  },
  mounted: function mounted() {
    this.$emit('loading', 'Waiting for the device...');
    this.interval = setInterval(this.sendRequest, __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* HEARTBEAT_ATTEMPT_INTERVAL */]);
  },

  methods: {
    sendRequest: function sendRequest() {
      var _this = this;

      if (this.requestOnGoing) return;

      this.requestOnGoing = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* API_URL */] + '/heart').then(function (res) {
        clearInterval(_this.interval);
        _this.$emit('loaded');
        _this.$emit('done');
      }).catch(function () {
        _this.requestOnGoing = false;
      });
    }
  }
});

/***/ }),
/* 32 */
/* exports provided: default */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/pipeline/source/~/babel-preset-vue-app/dist/index.common.js",{"useBuiltIns":true}]]}!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/steps/Info.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(/*! axios */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(/*! ../../constants */ 3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: true,
      apiResponse: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$emit('loading', 'Gathering device information...');
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* API_URL */] + '/device-info').then(function (res) {
      _this.$emit('loaded');
      _this.apiResponse = res.data;
      _this.$emit('deviceInformation', _this.apiResponse);
      _this.loading = false;
    }).catch(function () {});
  },

  methods: {
    sendDone: function sendDone() {
      this.$emit('done');
    }
  }
});

/***/ }),
/* 33 */
/* exports provided: default */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/pipeline/source/~/babel-preset-vue-app/dist/index.common.js",{"useBuiltIns":true}]]}!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/steps/Mqtt.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      passwordClearText: false,
      host: null,
      port: 1883,
      baseTopic: null,
      auth: false,
      username: null,
      password: null
    };
  },

  computed: {
    formIsValid: function formIsValid() {
      if (!this.host) return false;
      if (!this.port) return false;

      if (this.auth) {
        if (!this.username) return false;
        if (!this.password) return false;
      }

      return true;
    }
  },
  methods: {
    sendDone: function sendDone() {
      var mqtt = {};
      mqtt.host = this.host;
      mqtt.port = this.port;
      if (this.baseTopic) mqtt['base_topic'] = this.baseTopic;

      mqtt.auth = false;
      if (this.auth) {
        mqtt.auth = true;
        mqtt.username = this.username;
        mqtt.password = this.password;
      }

      this.$emit('mqttConfig', mqtt);
      this.$emit('done');
    }
  }
});

/***/ }),
/* 34 */
/* exports provided: default */
/* all exports used */
/*!************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/pipeline/source/~/babel-preset-vue-app/dist/index.common.js",{"useBuiltIns":true}]]}!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/steps/Sending.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(/*! axios */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(/*! ../../constants */ 3);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: true,
      apiResponse: null
    };
  },

  props: ['configuration'],
  mounted: function mounted() {
    var _this = this;

    this.$emit('loading', 'Sending configuration to the device...');
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* API_URL */] + '/config', this.configuration).then(function (res) {
      _this.$emit('loaded');
      _this.apiResponse = res.data;
      _this.loading = false;
    }).catch(function (err) {
      _this.$emit('loaded');
      if (err.response) _this.apiResponse = err.response.data;else _this.apiResponse = { error: err.message };
      _this.loading = false;
    });
  }
});

/***/ }),
/* 35 */
/* exports provided: default */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/pipeline/source/~/babel-preset-vue-app/dist/index.common.js",{"useBuiltIns":true}]]}!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/steps/Settings.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var customSettings = {};

    this.deviceInformation.settings.forEach(function (setting) {
      customSettings[setting.name] = setting.required ? null : setting.default;
    });
    return {
      name: null,
      deviceId: null,
      ota: false,
      customSettings: customSettings
    };
  },

  props: ['deviceInformation'],
  computed: {
    formIsValid: function formIsValid() {
      if (!this.name) return false;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.deviceInformation.settings[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var originalSetting = _step.value;

          if (originalSetting.required && this.customSettings[originalSetting.name] === '') return false;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return true;
    }
  },
  methods: {
    sendDone: function sendDone() {
      var settings = { settings: {} };
      settings.name = this.name;
      settings.ota = this.ota;
      if (this.deviceId) settings['device_id'] = this.deviceId;

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = Object.keys(this.customSettings)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var providedSettingName = _step2.value;

          var originalSettingObject = void 0;
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = this.deviceInformation.settings[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var settingObject = _step3.value;

              if (settingObject.name === providedSettingName) {
                originalSettingObject = settingObject;
                break;
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          if (originalSettingObject.required || originalSettingObject.default !== this.customSettings[providedSettingName]) {
            settings.settings[providedSettingName] = this.customSettings[providedSettingName];
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.$emit('settingsConfig', settings);
      this.$emit('done');
    }
  }
});

/***/ }),
/* 36 */
/* exports provided: default */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/pipeline/source/~/babel-preset-vue-app/dist/index.common.js",{"useBuiltIns":true}]]}!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/steps/Wifi.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(/*! axios */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(/*! ../../constants */ 3);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: true,
      apiResponse: null,
      ssid_select: 'select',
      ssid_input: null,
      password: null,
      passwordClearText: false
    };
  },

  computed: {
    formattedNetworks: function formattedNetworks() {
      var networks = this.apiResponse.networks.slice(0);
      networks.sort(function (networkA, networkB) {
        if (networkA.rssi > networkB.rssi) {
          return -1;
        } else if (networkA.rssi < networkB.rssi) {
          return 1;
        } else {
          return 0;
        }
      });

      networks = networks.map(function (network) {
        if (network.rssi <= -100) {
          network.signalQuality = 0;
        } else if (network.rssi >= -50) {
          network.signalQuality = 100;
        } else {
          network.signalQuality = 2 * (network.rssi + 100);
        }

        switch (network.encryption) {
          case 'wep':
            network.encryption = 'WEP';
            break;
          case 'wpa':
            network.encryption = 'WPA';
            break;
          case 'wpa2':
            network.encryption = 'WPA2';
            break;
          case 'none':
            network.encryption = 'Open';
            break;
          case 'auto':
            network.encryption = 'Automatic';
            break;
        }
        return network;
      });

      return networks;
    },
    computedSsid: function computedSsid() {
      if (_typeof(this.ssid_select) === 'object') return this.ssid_select.ssid;else if (this.ssid_select === 'other') return this.ssid_input;

      return null;
    },
    formIsValid: function formIsValid() {
      var needPassword = _typeof(this.ssid_select) === 'object' && this.ssid_select.encryption !== 'Open';

      return this.computedSsid && (!needPassword || this.password);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$emit('loading', 'Gathering available Wi-Fi networks...');
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* API_URL */] + '/networks').then(function (res) {
      _this.$emit('loaded');
      _this.apiResponse = res.data;
      _this.loading = false;
    }).catch(function () {});
  },

  methods: {
    sendDone: function sendDone() {
      this.$emit('wifiConfig', {
        ssid: this.computedSsid,
        password: _typeof(this.ssid_select) === 'object' && this.ssid_select.encryption === 'Open' ? null : this.password
      });

      this.$emit('done');
    }
  }
});

/***/ }),
/* 37 */,
/* 38 */,
/* 39 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0ec44bfe","scoped":true,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/steps/Info.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 40 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8f99b72e","scoped":false,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/App.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 41 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8f99b72e","scoped":true,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/App.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 42 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8f99b72e","scoped":true,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=2!./src/components/App.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 43 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dd07b324","scoped":true,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ProgressBar.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 44 */,
/* 45 */,
/* 46 */
/* no static exports found */
/* exports used: default */
/*!********************************!*\
  !*** ./src/components/App.vue ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../~/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-8f99b72e","scoped":true,"hasInlineConfig":true}!../../~/vue-loader/lib/selector?type=styles&index=0!./App.vue */ 41)
  __webpack_require__(/*! !../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../~/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-8f99b72e","scoped":false,"hasInlineConfig":true}!../../~/vue-loader/lib/selector?type=styles&index=1!./App.vue */ 40)
  __webpack_require__(/*! !../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../~/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-8f99b72e","scoped":true,"hasInlineConfig":true}!../../~/vue-loader/lib/selector?type=styles&index=2!./App.vue */ 42)
}
var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/pipeline/source/~/babel-preset-vue-app/dist/index.common.js",{"useBuiltIns":true}]]}!../../~/vue-loader/lib/selector?type=script&index=0!./App.vue */ 29),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-8f99b72e"}!../../~/vue-loader/lib/selector?type=template&index=0!./App.vue */ 59),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8f99b72e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 47 */
/* no static exports found */
/* exports used: default */
/*!****************************************!*\
  !*** ./src/components/ProgressBar.vue ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../~/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-dd07b324","scoped":true,"hasInlineConfig":true}!../../~/vue-loader/lib/selector?type=styles&index=0!./ProgressBar.vue */ 43)
}
var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/pipeline/source/~/babel-preset-vue-app/dist/index.common.js",{"useBuiltIns":true}]]}!../../~/vue-loader/lib/selector?type=script&index=0!./ProgressBar.vue */ 30),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-dd07b324"}!../../~/vue-loader/lib/selector?type=template&index=0!./ProgressBar.vue */ 61),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-dd07b324",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 48 */
/* no static exports found */
/* exports used: default */
/*!*********************************************!*\
  !*** ./src/components/steps/Connection.vue ***!
  \*********************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/pipeline/source/~/babel-preset-vue-app/dist/index.common.js",{"useBuiltIns":true}]]}!../../../~/vue-loader/lib/selector?type=script&index=0!./Connection.vue */ 31),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-5cfdb7a4"}!../../../~/vue-loader/lib/selector?type=template&index=0!./Connection.vue */ 56),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 49 */
/* no static exports found */
/* exports used: default */
/*!***************************************!*\
  !*** ./src/components/steps/Info.vue ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../~/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-0ec44bfe","scoped":true,"hasInlineConfig":true}!../../../~/vue-loader/lib/selector?type=styles&index=0!./Info.vue */ 39)
}
var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/pipeline/source/~/babel-preset-vue-app/dist/index.common.js",{"useBuiltIns":true}]]}!../../../~/vue-loader/lib/selector?type=script&index=0!./Info.vue */ 32),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-0ec44bfe"}!../../../~/vue-loader/lib/selector?type=template&index=0!./Info.vue */ 54),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0ec44bfe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/* no static exports found */
/* exports used: default */
/*!***************************************!*\
  !*** ./src/components/steps/Mqtt.vue ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/pipeline/source/~/babel-preset-vue-app/dist/index.common.js",{"useBuiltIns":true}]]}!../../../~/vue-loader/lib/selector?type=script&index=0!./Mqtt.vue */ 33),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-6525ff74"}!../../../~/vue-loader/lib/selector?type=template&index=0!./Mqtt.vue */ 57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 51 */
/* no static exports found */
/* exports used: default */
/*!******************************************!*\
  !*** ./src/components/steps/Sending.vue ***!
  \******************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/pipeline/source/~/babel-preset-vue-app/dist/index.common.js",{"useBuiltIns":true}]]}!../../../~/vue-loader/lib/selector?type=script&index=0!./Sending.vue */ 34),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-14b78b8c"}!../../../~/vue-loader/lib/selector?type=template&index=0!./Sending.vue */ 55),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 52 */
/* no static exports found */
/* exports used: default */
/*!*******************************************!*\
  !*** ./src/components/steps/Settings.vue ***!
  \*******************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/pipeline/source/~/babel-preset-vue-app/dist/index.common.js",{"useBuiltIns":true}]]}!../../../~/vue-loader/lib/selector?type=script&index=0!./Settings.vue */ 35),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-7ee3761a"}!../../../~/vue-loader/lib/selector?type=template&index=0!./Settings.vue */ 58),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/* no static exports found */
/* exports used: default */
/*!***************************************!*\
  !*** ./src/components/steps/Wifi.vue ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 1)(
  /* script */
  __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/pipeline/source/~/babel-preset-vue-app/dist/index.common.js",{"useBuiltIns":true}]]}!../../../~/vue-loader/lib/selector?type=script&index=0!./Wifi.vue */ 36),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-977dea36"}!../../../~/vue-loader/lib/selector?type=template&index=0!./Wifi.vue */ 60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 54 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ec44bfe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/steps/Info.vue ***!
  \**********************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(!_vm.loading) ? _c('span', [_c('p', [_vm._v("\n      Here are some information about the device you are about to configure:\n    ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._m(0), _vm._v(" "), _c('b', [_vm._v("Hardware device ID:")]), _vm._v(" "), _c('span', {
    staticClass: "tag is-dark"
  }, [_vm._v(_vm._s(_vm.apiResponse.hardware_device_id))])]), _vm._v(" "), _c('li', [_vm._m(1), _vm._v(" "), _c('b', [_vm._v("Homie for ESP8266 version:")]), _vm._v(" "), _c('span', {
    staticClass: "tag is-dark"
  }, [_vm._v(_vm._s(_vm.apiResponse.homie_esp8266_version))])]), _vm._v(" "), _c('li', [_vm._m(2), _vm._v(" "), _c('b', [_vm._v("Firmware")]), _vm._v(" "), _c('ul', [_c('li', [_c('b', [_vm._v("Name:")]), _vm._v(" "), _c('span', {
    staticClass: "tag is-dark"
  }, [_vm._v(_vm._s(_vm.apiResponse.firmware.name))])]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Version:")]), _vm._v(" "), _c('span', {
    staticClass: "tag is-dark"
  }, [_vm._v(_vm._s(_vm.apiResponse.firmware.version))])])])]), _vm._v(" "), _c('li', [_vm._m(3), _vm._v(" "), _c('b', [_vm._v("Nodes:")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.apiResponse.nodes), function(node) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(node.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(node.type))])])
  }))])])]), _vm._v(" "), _c('a', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.sendDone
    }
  }, [_vm._v("Next")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-hashtag"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-tag"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-font"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-cubes"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-hashtag"
  })]), _vm._v(" ID")]), _vm._v(" "), _c('th', [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-link"
  })]), _vm._v(" Type")])])])
}]}

/***/ }),
/* 55 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-14b78b8c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/steps/Sending.vue ***!
  \*************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loading) ? _c('span', [(_vm.apiResponse.success === true) ? _c('div', {
    staticClass: "notification is-success"
  }, [_vm._v("\n    The configuration was sent. Your device will reboot. You can close this page.\n  ")]) : _c('div', {
    staticClass: "notification is-danger"
  }, [_vm._v("\n    There was an error while sending the configuration: " + _vm._s(_vm.apiResponse.error) + "\n    "), _c('br'), _vm._v("\n    Please retry or report if it looks like a bug.\n  ")])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 56 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cfdb7a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/steps/Connection.vue ***!
  \****************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n  Connect to your device Wi-Fi AP. It should be named something like "), _c('strong', [_vm._v("Homie-123456abcdef")]), _vm._v(".\n  Note this configurator is only for Homie for ESP8266 v2. The v1 configurator is available "), _c('a', {
    attrs: {
      "href": "https://github.com/marvinroger/homie-esp8266/releases/download/v1.5.0/homie-esp8266-v1-setup.zip"
    }
  }, [_vm._v("here")]), _vm._v(".\n")])
}]}

/***/ }),
/* 57 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-6525ff74"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/steps/Mqtt.vue ***!
  \**********************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('p', [_vm._v("\n    Enter the MQTT credentials.\n  ")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.sendDone($event)
      }
    }
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "mqtt_broker_address"
    }
  }, [_vm._v("MQTT broker address")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.host),
      expression: "host",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "id": "mqtt_broker_address",
      "placeholder": "IP or hostname",
      "pattern": "^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$|^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\\-]*[a-zA-Z0-9])\\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\\-]*[A-Za-z0-9])$",
      "required": ""
    },
    domProps: {
      "value": (_vm.host)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.host = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help"
  }, [_vm._v("Required.")])]), _vm._v(" "), _c('label', {
    staticClass: "label",
    attrs: {
      "for": "mqtt_broker_port"
    }
  }, [_vm._v("MQTT broker port")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.port),
      expression: "port",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "step": "1",
      "min": "1",
      "max": "65535",
      "id": "mqtt_broker_port",
      "placeholder": "Port number",
      "required": ""
    },
    domProps: {
      "value": (_vm.port)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.port = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help"
  }, [_vm._v("Required.")])]), _vm._v(" "), _c('label', {
    staticClass: "label",
    attrs: {
      "for": "homie_base_topic"
    }
  }, [_vm._v("Homie base topic")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.baseTopic),
      expression: "baseTopic",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "id": "homie_base_topic",
      "placeholder": "Base topic"
    },
    domProps: {
      "value": (_vm.baseTopic)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.baseTopic = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.auth),
      expression: "auth"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.auth) ? _vm._i(_vm.auth, null) > -1 : (_vm.auth)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.auth,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.auth = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.auth = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.auth = $$c
        }
      }
    }
  }), _vm._v(" Use MQTT authentication\n      ")])]), _vm._v(" "), (_vm.auth) ? _c('div', [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "mqtt_username"
    }
  }, [_vm._v("MQTT username")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.username),
      expression: "username",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "id": "mqtt_username",
      "placeholder": "Username",
      "required": ""
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help"
  }, [_vm._v("Required.")])]), _vm._v(" "), _c('label', {
    staticClass: "label",
    attrs: {
      "for": "mqtt_password"
    }
  }, [_vm._v("MQTT password")]), _vm._v(" "), _c('p', {
    staticClass: "control is-grouped"
  }, [(_vm.passwordClearText) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "autocapitalize": "none",
      "id": "mqtt_password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "id": "mqtt_password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordClearText),
      expression: "passwordClearText"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.passwordClearText) ? _vm._i(_vm.passwordClearText, null) > -1 : (_vm.passwordClearText)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.passwordClearText,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.passwordClearText = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.passwordClearText = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.passwordClearText = $$c
        }
      }
    }
  }), _vm._v(" Show password\n        ")])]), _vm._v(" "), _c('span', {
    staticClass: "help"
  }, [_vm._v("Required.")]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "submit",
      "disabled": !_vm.formIsValid
    }
  }, [_vm._v("Next")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "help"
  }, [_vm._v("Optional. The default value is "), _c('span', {
    staticClass: "tag"
  }, [_vm._v("homie/")]), _vm._v(".")])
}]}

/***/ }),
/* 58 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ee3761a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/steps/Settings.vue ***!
  \**************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('p', [_vm._v("\n    Configure the settings for your device.\n  ")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.sendDone($event)
      }
    }
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "friendly_name"
    }
  }, [_vm._v("Friendly name")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.name),
      expression: "name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "My awesome device name",
      "id": "friendly_name",
      "required": ""
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help"
  }, [_vm._v("Required.")])]), _vm._v(" "), _c('label', {
    staticClass: "label",
    attrs: {
      "for": "device_id"
    }
  }, [_vm._v("Device ID")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.deviceId),
      expression: "deviceId",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "pattern": "^(([a-z0-9]|[a-z0-9][a-z0-9\\-]*[a-z0-9]))$",
      "placeholder": "the-device-id",
      "id": "device_id"
    },
    domProps: {
      "value": (_vm.deviceId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deviceId = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox",
    attrs: {
      "for": "ota"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ota),
      expression: "ota"
    }],
    attrs: {
      "type": "checkbox",
      "id": "ota"
    },
    domProps: {
      "checked": Array.isArray(_vm.ota) ? _vm._i(_vm.ota, null) > -1 : (_vm.ota)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.ota,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.ota = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.ota = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.ota = $$c
        }
      }
    }
  }), _vm._v(" Enable OTA\n      ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.deviceInformation.settings.length === 0) ? _c('p', [_vm._v("No custom settings.")]) : [_c('p'), _c('h3', [_vm._v("Custom settings")]), _vm._v(" "), _vm._l((_vm.deviceInformation.settings), function(setting) {
    return [(setting.type === 'bool') ? [_c('p', {
      staticClass: "control"
    }, [_c('label', {
      staticClass: "checkbox",
      attrs: {
        "for": 'custom_setting_' + setting.name
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.customSettings[setting.name]),
        expression: "customSettings[setting.name]"
      }],
      attrs: {
        "type": "checkbox",
        "id": 'custom_setting_' + setting.name
      },
      domProps: {
        "checked": Array.isArray(_vm.customSettings[setting.name]) ? _vm._i(_vm.customSettings[setting.name], null) > -1 : (_vm.customSettings[setting.name])
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.customSettings[setting.name],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.customSettings[setting.name] = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.customSettings[setting.name] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            var $$exp = _vm.customSettings,
              $$idx = setting.name;
            if (!Array.isArray($$exp)) {
              _vm.customSettings[setting.name] = $$c
            } else {
              $$exp.splice($$idx, 1, $$c)
            }
          }
        }
      }
    }), _vm._v(" " + _vm._s(setting.description) + "\n              ")]), _vm._v(" "), _c('span', {
      staticClass: "help",
      domProps: {
        "innerHTML": _vm._s(setting.required ? 'Required.' : 'Optional. Defaults to <span class=\'tag\'>' + setting.default+'</span>.')
      }
    })])] : [_c('label', {
      staticClass: "label",
      attrs: {
        "for": 'custom_setting_' + setting.name
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: {
        fa: true, 'fa-hashtag': setting.type === 'long' || setting.type === 'ulong' || setting.type === 'double', 'fa-font': setting.type === 'string'
      }
    })]), _vm._v(" " + _vm._s(setting.type === 'double' ? '(float)' : '') + " " + _vm._s(setting.type === 'ulong' ? '(unsigned)' : '') + " " + _vm._s(setting.description))]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [(setting.type === 'ulong') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.customSettings[setting.name]),
        expression: "customSettings[setting.name]",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "input",
      attrs: {
        "type": "number",
        "step": "1",
        "min": "0",
        "max": "4294967295",
        "id": 'custom_setting_' + setting.name
      },
      domProps: {
        "value": (_vm.customSettings[setting.name])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = _vm.customSettings,
            $$idx = setting.name;
          if (!Array.isArray($$exp)) {
            _vm.customSettings[setting.name] = _vm._n($event.target.value)
          } else {
            $$exp.splice($$idx, 1, _vm._n($event.target.value))
          }
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }) : _vm._e(), _vm._v(" "), (setting.type === 'long') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.customSettings[setting.name]),
        expression: "customSettings[setting.name]",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "input",
      attrs: {
        "type": "number",
        "step": "1",
        "min": "-2147483648",
        "max": "2147483647",
        "id": 'custom_setting_' + setting.name
      },
      domProps: {
        "value": (_vm.customSettings[setting.name])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = _vm.customSettings,
            $$idx = setting.name;
          if (!Array.isArray($$exp)) {
            _vm.customSettings[setting.name] = _vm._n($event.target.value)
          } else {
            $$exp.splice($$idx, 1, _vm._n($event.target.value))
          }
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }) : _vm._e(), _vm._v(" "), (setting.type === 'double') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.customSettings[setting.name]),
        expression: "customSettings[setting.name]",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "input",
      attrs: {
        "type": "number",
        "step": "any",
        "id": 'custom_setting_' + setting.name
      },
      domProps: {
        "value": (_vm.customSettings[setting.name])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = _vm.customSettings,
            $$idx = setting.name;
          if (!Array.isArray($$exp)) {
            _vm.customSettings[setting.name] = _vm._n($event.target.value)
          } else {
            $$exp.splice($$idx, 1, _vm._n($event.target.value))
          }
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }) : _vm._e(), _vm._v(" "), (setting.type === 'string') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (_vm.customSettings[setting.name]),
        expression: "customSettings[setting.name]",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "id": 'custom_setting_' + setting.name
      },
      domProps: {
        "value": (_vm.customSettings[setting.name])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = _vm.customSettings,
            $$idx = setting.name;
          if (!Array.isArray($$exp)) {
            _vm.customSettings[setting.name] = $event.target.value.trim()
          } else {
            $$exp.splice($$idx, 1, $event.target.value.trim())
          }
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "help",
      domProps: {
        "innerHTML": _vm._s(setting.required ? 'Required.' : 'Optional. Defaults to <span class=\'tag\'>' + setting.default+'</span>.')
      }
    })])]]
  }), _vm._v(" "), _c('p')], _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "submit",
      "disabled": !_vm.formIsValid
    }
  }, [_vm._v("Next")])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "help"
  }, [_vm._v("Optional. The default value is the hardware device ID. MAY be composed of lowercase letters from "), _c('span', {
    staticClass: "tag"
  }, [_vm._v("a")]), _vm._v(" to "), _c('span', {
    staticClass: "tag"
  }, [_vm._v("z")]), _vm._v(", numbers from "), _c('span', {
    staticClass: "tag"
  }, [_vm._v("0")]), _vm._v(" to "), _c('span', {
    staticClass: "tag"
  }, [_vm._v("9")]), _vm._v(", and it MAY contain "), _c('span', {
    staticClass: "tag"
  }, [_vm._v("-")]), _vm._v(", but MUST NOT start or end with a "), _c('span', {
    staticClass: "tag"
  }, [_vm._v("-")])])
}]}

/***/ }),
/* 59 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f99b72e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue ***!
  \***************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Homie for ESP8266")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Set up your device.")]), _vm._v(" "), _c('progress-bar', {
    attrs: {
      "current-step": _vm.currentStep
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.currentStep === 1) ? _c('connection-step', {
    on: {
      "done": _vm.goToNextStep,
      "loading": _vm.setLoading,
      "loaded": _vm.stopLoading
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentStep === 2) ? _c('info-step', {
    on: {
      "deviceInformation": _vm.receiveDeviceInformation,
      "done": _vm.goToNextStep,
      "loading": _vm.setLoading,
      "loaded": _vm.stopLoading
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentStep === 3) ? _c('wifi-step', {
    on: {
      "wifiConfig": _vm.receiveWifiConfig,
      "done": _vm.goToNextStep,
      "loading": _vm.setLoading,
      "loaded": _vm.stopLoading
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentStep === 4) ? _c('mqtt-step', {
    on: {
      "mqttConfig": _vm.receiveMqttConfig,
      "done": _vm.goToNextStep
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentStep === 5) ? _c('settings-step', {
    attrs: {
      "device-information": _vm.deviceInformation
    },
    on: {
      "settingsConfig": _vm.receiveSettingsConfig,
      "done": _vm.goToNextStep
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentStep === 6) ? _c('sending-step', {
    attrs: {
      "configuration": _vm.config
    },
    on: {
      "loading": _vm.setLoading,
      "loaded": _vm.stopLoading
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "notification"
  }, [_c('span', {
    staticClass: "button is-loading"
  }, [_vm._v("Loading")]), _vm._v(" " + _vm._s(_vm.loadingText) + "\n    ")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 60 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-977dea36"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/steps/Wifi.vue ***!
  \**********************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loading) ? _c('span', [_c('p', [_vm._v("\n    Select the Wi-Fi network to connect to:\n  ")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.sendDone($event)
      }
    }
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "wifi_network"
    }
  }, [_vm._v("Network")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ssid_select),
      expression: "ssid_select"
    }],
    attrs: {
      "id": "wifi_network"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ssid_select = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "select"
    }
  }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.formattedNetworks), function(network) {
    return _c('option', {
      domProps: {
        "value": network
      }
    }, [_vm._v("\n            " + _vm._s(network.ssid) + " - " + _vm._s(network.encryption) + " (" + _vm._s(network.signalQuality) + "%)\n          ")])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other/hidden network")])], 2)])]), _vm._v(" "), (_vm.ssid_select === 'other') ? _c('div', [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "wifi_ssid"
    }
  }, [_vm._v("Wi-Fi SSID")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.ssid_input),
      expression: "ssid_input",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "id": "wifi_ssid",
      "type": "text",
      "placeholder": "SSID",
      "maxLength": "32",
      "required": ""
    },
    domProps: {
      "value": (_vm.ssid_input)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ssid_input = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help"
  }, [_vm._v("Required.")])])]) : _vm._e(), _vm._v(" "), (typeof _vm.ssid_select === 'object' && _vm.ssid_select.encryption !== 'Open' || _vm.ssid_select === 'other') ? _c('div', [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "wifi_password"
    }
  }, [_vm._v("Wi-Fi password")]), _vm._v(" "), _c('p', {
    staticClass: "control is-grouped"
  }, [(_vm.passwordClearText) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "autocapitalize": "none",
      "id": "wifi_password",
      "placeholder": "Password",
      "maxLength": "64"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "id": "wifi_password",
      "placeholder": "Password",
      "maxLength": "64"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordClearText),
      expression: "passwordClearText"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.passwordClearText) ? _vm._i(_vm.passwordClearText, null) > -1 : (_vm.passwordClearText)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.passwordClearText,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.passwordClearText = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.passwordClearText = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.passwordClearText = $$c
        }
      }
    }
  }), _vm._v(" Show password\n        ")])]), _vm._v(" "), _c('span', {
    staticClass: "help"
  }, [_vm._v("Optional. Leave blank if open network.")]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "submit",
      "disabled": !_vm.formIsValid
    }
  }, [_vm._v("Next")])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 61 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd07b324"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProgressBar.vue ***!
  \***********************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs is-centered"
  }, [_c('ul', [_c('li', {
    class: {
      'is-active': _vm.currentStep === 1
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-heartbeat"
  }), _vm._v(" " + _vm._s(_vm.currentStep === 1 ? 'Connection' : ''))])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.currentStep === 2
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-info"
  }), _vm._v(" " + _vm._s(_vm.currentStep === 2 ? 'Information' : ''))])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.currentStep === 3
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-wifi"
  }), _vm._v(" " + _vm._s(_vm.currentStep === 3 ? 'Wi-Fi' : ''))])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.currentStep === 4
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-signal"
  }), _vm._v(" " + _vm._s(_vm.currentStep === 4 ? 'MQTT' : ''))])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.currentStep === 5
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-cogs"
  }), _vm._v(" " + _vm._s(_vm.currentStep === 5 ? 'Settings' : ''))])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.currentStep === 6
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-rocket"
  }), _vm._v(" " + _vm._s(_vm.currentStep === 6 ? 'Launch' : ''))])])])])
},staticRenderFns: []}

/***/ }),
/* 62 */,
/* 63 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** multi ./src/index.js ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /pipeline/source/src/index.js */11);


/***/ })
],[63]);


// WEBPACK FOOTER //
// client.3b540e6f.js